import client from './client';

export type ModelGenJobType = 'text' | 'image' | 'texture' | 'retopo' | 'segment';

export interface ModelGenArtifact {
  kind: 'glb' | 'png' | 'texture' | 'json';
  url: string;
  meta?: Record<string, unknown>;
}

export interface ModelGenJob {
  id: string;
  type: ModelGenJobType;
  provider: string | null;
  status: 'queued' | 'running' | 'succeeded' | 'failed' | 'canceled';
  chain: string[];
  input: Record<string, unknown>;
  result: { artifacts: ModelGenArtifact[]; providers: string[]; durationMs: number } | null;
  error: string | null;
  createdAt: string;
  startedAt?: string | null;
  finishedAt?: string | null;
}

export interface ModelGenProviderView {
  code: string;
  name: string;
  available: boolean;
  supports: string[];
}

export async function fetchModelGenProviders(): Promise<{ enabled: boolean; items: ModelGenProviderView[] }> {
  const { data } = await client.get('/model-gen/providers');
  return data;
}

export async function createModelGenJob(body: {
  type: ModelGenJobType;
  prompt?: string;
  imageUrl?: string;
  modelUrl?: string;
  budget?: { tris?: number; maxSeconds?: number };
  params?: Record<string, unknown>;
}): Promise<{ jobId: string; status: string; chain: string[] }> {
  const { data } = await client.post('/model-gen/jobs', body);
  return data;
}

export async function fetchModelGenJob(id: string): Promise<ModelGenJob> {
  const { data } = await client.get(`/model-gen/jobs/${id}`);
  return data;
}

export async function cancelModelGenJob(id: string): Promise<{ canceled: boolean }> {
  const { data } = await client.post(`/model-gen/jobs/${id}/cancel`, {});
  return data;
}

export async function adoptModelGenJob(
  id: string,
  body: { sceneId: string },
): Promise<{ model: { id: string; name: string; url: string; aiGenerated: boolean } }> {
  const { data } = await client.post(`/model-gen/jobs/${id}/adopt`, body);
  return data;
}

export async function applyModelGenTexture(
  id: string,
  body: { modelId: string },
): Promise<{ model: { id: string; name: string; materials: unknown; aiGenerated: boolean }; textureUrl: string; color: string }> {
  const { data } = await client.post(`/model-gen/jobs/${id}/apply-texture`, body);
  return data;
}
